import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import {
  agruparPreferenciasNotificacao,
  PreferenciaNotificacaoService,
} from 'src/app/shared/services/preferencia-notificacao.service';
import { PreferenciaNotificacaoModel } from 'src/app/core/models/preferencia-notificacao.model';
import { CardHeaderButton } from 'src/app/shared/components/card/card.component';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-preferencia-notificacao',
  templateUrl: './preferencia-notificacao.component.html',
  styleUrl: './preferencia-notificacao.component.css',
})
export class PreferenciaNotificacaoComponent implements OnInit {
  preferencias: PreferenciaNotificacaoModel[] = [];
  grupos: { categoria: string; itens: PreferenciaNotificacaoModel[] }[] = [];
  carregando = true;
  readonly accentPerfil = 'perfil';

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private preferenciaService: PreferenciaNotificacaoService,
    private router: Router,
    private location: Location,
  ) {}

  ngOnInit(): void {
    this.preferenciaService.refresh();
    this.preferenciaService
      .getPreferencias()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(preferencias => {
        this.preferencias = preferencias;
        this.grupos = agruparPreferenciasNotificacao(preferencias);
        this.carregando = false;
      });
  }

  onToggle(preferencia: PreferenciaNotificacaoModel, event: MatSlideToggleChange): void {
    this.preferenciaService.atualizarPreferencia(preferencia.tipo, event.checked);
  }

  voltar(): void {
    this.location.back();
  }

  get headerButtons(): CardHeaderButton[] {
    return [
      {
        type: 'button-outline',
        label: 'Voltar',
        callBack: this.voltar.bind(this),
      },
    ];
  }
}
